import React from 'react';
import classNames from 'classnames';
import { descriptionsClasses } from '../../descriptions.styled';
import Typography from '@components/ui/typography';

interface DescriptionsPrefixProps {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const DescriptionsPrefix: React.FunctionComponent<DescriptionsPrefixProps> = ({
  children,
  style,
  className,
}) => {
  return (
    <Typography
      display="body1"
      variant="strong"
      as="span"
      className={classNames(descriptionsClasses.prefixItem, className)}
      style={style}
      noWrap
    >
      {children}
    </Typography>
  );
};

export default DescriptionsPrefix;
